import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styles/styled-components';
import messages from '../messages';
import Kamereo from 'components/MainNav/Kamereo.svg';
import media from 'utils/mediaStyle';

import { messageIcon, gyomuLogo } from '../images';

const MessageWrapper = styled.div`
  position: relative;
  margin-bottom: 24px;
  padding: 20px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #eaeaeb;
  background: #fafafa;
  ${media.lg`
    padding: 20px 120px;
    margin-bottom: 48px;
  `};
`;
const Message = styled.p`
  text-align: left;
  font-size: 14px;
  font-style: italic;
  font-weight: 500;
  line-height: 20px;
  ${media.lg`
   text-align: center;
   font-size: 24px;
   line-height: 28px;
  `};
`;

const SubMessage = styled.p`
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
  width: 100%;
  ${media.lg`
   text-align: center;
   font-size: 20px;
   line-height: 28px;
  `};
`;

const FindMoreContainer = styled.p`
  text-align: left;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  width: 100%;
  ${media.lg`
    text-align:center;
    font-size: 20px;
    line-height: 28px;
   `};
`;

const ClickHereContainer = styled.a`
  margin-left: 4px;
  color: #43a047;
  text-decoration-line: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 1px;
  cursor: pointer;

  &:hover {
    color: #43a047;
    font-weight: 500;
    text-decoration-line: underline;
    text-underline-offset: 3px;
    text-decoration-thickness: 2px;
  }
`;

const MessageIconContainer = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-25%, -50%);
  z-index: 50 !important;
  width: 35px;

  ${media.lg`
    width: auto;
   `};
`;

const KamereoLogoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  ${media.lg`
  justify-content: center;
  gap: 40px; 
   `};
`;

const BrandLogo = styled.img`
  width: 120px;
  ${media.lg`
    width: auto;
   `};
`;
const GyomuLogo = styled.img`
  width: 115px;
  margin-top: 4px;
  ${media.lg`
  width: 210px;
   `};
`;
const XCharacter = styled.div`
  font-size: 18px;
  font-weight: 400;
  ${media.lg`
  font-size: 50px;
   `};
`;
const GyomuSuperText = styled.strong`
  display: block;
  text-align: right;
  margin-left: 5px;
  ${media.lg`
    display: inline
    text-align: unset;
   `};
`;

const GyomuSuperMessage = () => {
  return (
    <MessageWrapper>
      <Message>
        <FormattedMessage {...messages.gyomuSuperTarget} />
        <GyomuSuperText>Gyomu Super</GyomuSuperText>
      </Message>
      <SubMessage>
        <FormattedMessage {...messages.affirmative} />
      </SubMessage>
      <KamereoLogoContainer>
        <GyomuLogo src={gyomuLogo} alt="Gyomu super" />
        <XCharacter>X</XCharacter>
        <BrandLogo src={Kamereo} alt="KAMEREO - Đối tác cung cấp thực phẩm uy tín" />
      </KamereoLogoContainer>
      <FindMoreContainer>
        <FormattedMessage {...messages.learnMore} />
        <ClickHereContainer target="_blank" href="https://www.gyomusuper.jp/english/safety/index.php">
          <FormattedMessage {...messages.clickHere} />
        </ClickHereContainer>
      </FindMoreContainer>
      <MessageIconContainer src={messageIcon} />
    </MessageWrapper>
  );
};

export default GyomuSuperMessage;
